import { render } from "./BlogPosts.vue?vue&type=template&id=139a7d3a&scoped=true"
import script from "./BlogPosts.vue?vue&type=script&lang=js"
export * from "./BlogPosts.vue?vue&type=script&lang=js"

import "./BlogPosts.vue?vue&type=style&index=0&id=139a7d3a&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139a7d3a"]])

export default __exports__